import * as yup from "yup";

export const isValidCustomerEmail = (email) => quosal.util.isValidEmail(email);

export const getCustomerEmailYupRule = () =>
	yup
		.string()
		.trim()
		.required("Email is a required field")
		.test("is-valid-email", "Invalid Email field", (value) => isValidCustomerEmail(value))
		.max(255, "Email must not be greater than 255 characters long");
